export const environment = {
    production: true,
    apiUrl: 'https://yxadmin-aws.transnetyx.com/api',

    auth0: {
        domain: 'login.transnetyx.com',
        clientId: '6Np9bgSsypde3LIK31fYiosu0QYZyqMn',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts.transnetyx.com/v2/logout/order-manager`,
        logoutUrl: 'https://login.transnetyx.com/v2/logout',
    },

    colonyUrl: 'https://colony.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder.transnetyx.com/MVC/Account/Register',
    quickorderStrainUrl: 'https://quickorder.transnetyx.com/Strain.aspx',

    omDashboardUrl: 'https://ordermanager.transnetyx.com/',
    omAccountsUrl: 'https://ordermanager.transnetyx.com/Accounts/Default.aspx',
    omAssaysUrl: 'https://ordermanager.transnetyx.com/AssayDesign/Default.aspx',
    omOrdersUrl: 'https://ordermanager.transnetyx.com/Orders/Default.aspx',
    omPricingUrl: 'https://ordermanager.transnetyx.com/Pricing/Default.aspx',
    omProbesUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/Default.aspx',
    omPmUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/Default.aspx',
    omSalesUrl: 'https://ordermanager.transnetyx.com/Sales/Dashboard.aspx',
    omShippingUrl: 'https://ordermanager.transnetyx.com/Shipping/SupplyRequests.aspx',
    omStrainsUrl: 'https://ordermanager.transnetyx.com/Strains/Default.aspx',
    omTagCenterUrl: 'https://ordermanager.transnetyx.com/TAG/Default.aspx',
    omAccountOverviewUrl: 'https://ordermanager.transnetyx.com/Accounts/User.aspx',
    omBannerSettingsUrl: 'https://ordermanager.transnetyx.com/Admin/Banners/Default.aspx',
    omAccountsOrganizationsUrl: 'https://ordermanager.transnetyx.com/Accounts/Organizations.aspx',
    omAccountsOnlineUsersUrl: 'https://ordermanager.transnetyx.com/Accounts/UsersOnline.aspx',
    omAssaysSearchUrl: 'https://ordermanager.transnetyx.com/AssayDesign/Search.aspx',
    omAssaysSequencingUrl: 'https://ordermanager.transnetyx.com/AssayDesign/Sequencing.aspx',
    omAssaysProbesMfgUrl: 'https://ordermanager.transnetyx.com/AssayDesign/ProbeManufacturing.aspx',
    omAssaysIncompleteSIFsUrl: 'https://ordermanager.transnetyx.com/AssayDesign/IncompleteStrainInformationForms.aspx',
    omAssaysConstructsUrl: 'https://ordermanager.transnetyx.com/AssayDesign/Constructs.aspx',
    omOrdersCreateUrl: 'https://ordermanager.transnetyx.com/Orders/OrderCreate.aspx',
    omOrdersPendingOrdersUrl: 'https://ordermanager.transnetyx.com/Orders/OrdersPending.aspx',
    omOrdersIncompleteOrdersUrl: 'https://ordermanager.transnetyx.com/Orders/OrdersIncomplete.aspx',
    omOrdersWellplateStorageUrl: 'https://ordermanager.transnetyx.com/Orders/WellplateStorage.aspx',
    omPricingPromoCreditsUrl: 'https://ordermanager.transnetyx.com/Pricing/Discounting.aspx',
    omPricingPaymentMethodsUrl: 'https://ordermanager.transnetyx.com/Pricing/PaymentMethods.aspx',
    omProbesAddPredefinedProbesUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/PredefinedProbeAdd.aspx',
    omProbesABIFileImportUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/AbiOrderFileImport.aspx',
    omProbesManufacturingUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/Manufacturing.aspx',
    omProbesSequencingUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/Sequencing.aspx',
    omProbesIncompatibleProbesUrl: 'https://ordermanager.transnetyx.com/PredefinedProbes/IncompatibleProbes.aspx',
    omPmTasksUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/Tasks.aspx',
    omPmNotesUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/Notes.aspx',
    omPmOrdersLimsUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/OrdersLims.aspx',
    omPmPendingOrdersUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/OrdersPending.aspx',
    omPmOfflineWellplatesUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/WellplatesOffline.aspx',
    omPmOfflineSequencingUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/SequencingTubesOffline.aspx',
    omPmStrainCopyUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/StrainCopy.aspx',
    omPmUnreceivedOrdersUrl: 'https://ordermanager.transnetyx.com/ProjectManagement/OrdersNotReceived.aspx',
    omSalesAssayDesignUrl: 'https://ordermanager.transnetyx.com/Sales/AssayDesign.aspx',
    omSalesNotesUrl: 'https://ordermanager.transnetyx.com/Sales/Notes.aspx',
    omSalesProspectsUrl: 'https://ordermanager.transnetyx.com/Sales/SalesProspects.aspx',
    omShippingCentralShippingUrl: 'https://ordermanager.transnetyx.com/Shipping/CentralShipping.aspx',
    omShippingSequencingUrl: 'https://ordermanager.transnetyx.com/Shipping/Sequencing.aspx',
    omShippingLabelSettingsUrl: 'https://ordermanager.transnetyx.com/Shipping/LabelSettings.aspx',
    omOrderResultsUrl: 'https://ordermanager.transnetyx.com/Orders/OrderResults.aspx',
    omStrainUrl: 'https://ordermanager.transnetyx.com/Strains/Strain.aspx',
    omManagePickupsUrl: 'https://ordermanager.transnetyx.com/Shipping/ManagePickups.aspx',
};
